(function ($) {
  /*  ==========================================================================
			PHP Variables
			========================================================================== */

  // If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
  // which has been passed in via enqueue-scripts.php

  /*  ==========================================================================
			Grid variables - needed for featured_carousels__init
			========================================================================== */

  // NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
  var $grid_sizes = {
    sm: "550",
    md: "700",
    lg: "1000",
    xl: "1200",
    ws: "1400",
    xw: "1600"
  };

  /*  ==========================================================================
			Device Detection - Check if is mobile or ipad
			========================================================================== */

  var isMobile = false; // initiate as false
  var isTouchDevice = !!("ontouchstart" in window);

  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  }

  /*  ==========================================================================
			links
			========================================================================== */

  links__init();

  function links__init() {
    var $links = $("a").not(".noline, .noline a, .line--added");

    $links.each(function () {
      var $this = $(this);
      var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

      if ($("img", $this).length < 1) {
        $this.wrapInner("<span class='linkline'>");
        $this.addClass("line--added");
        if ($icon.length > 0) {
          if ($icon.hasClass("fa--left")) {
            $icon.insertBefore($(".linkline", $this));
          } else {
            $icon.insertAfter($(".linkline", $this));
          }
        }
      }
    });
  } // links__init()

  /*  ==========================================================================
			Seperate letters in button text to create hover effect
			========================================================================== */

  btns__init();

  function btns__init() {
    var $btns = $(".btn:not(.nf-fu-fileinput-button)");
    $btns.each(function () {
      var $this = $(this);
      var $icon = $(".fa, .fas, .far, .fal, .fab", $this);
      if (!$this.find(".btn__textwrap").length) {
        // Add wrapping spans, if they are not already setup
        $this.wrapInner("<span class='btn__textwrap'>");
        $this.find(".btn__textwrap").wrapInner("<span class='btn__text'>");
        $this.find(".btn__text").clone().appendTo($this.find(".btn__textwrap"));
        if ($icon.length > 0) {
          if ($icon.hasClass("fa--left")) {
            $icon.insertBefore($(".btn__textwrap", $this));
          } else {
            $icon.insertAfter($(".btn__textwrap", $this));
          }
        }
      }
      $this.find(".btn__text").each(function () {
        var $this = $(this);
        // Change spaces for &nbsp
        var $this_text = $this.html();
        $this_text = $this_text.replace(/\s/g, "&nbsp;");
        $this.html($this_text);
        // Run lettering js
        $this.lettering();
      });
    });
  } // btns__init()

  // re-init buttons for form ready
  jQuery(document).on("nfFormReady", function () {
    btns__init();
  });

  setTimeout(function () {
    btns__init();
  }, 2000);

  /*  ==========================================================================
			sharinglinks
			========================================================================== */

  $(".sharelink--popup").click(function (e) {
    e.preventDefault();
    window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
  });

  /*  ==========================================================================
			accordion
			========================================================================== */
  var $accordionItem = $(".accordion__item");

  $(".accordion__question").click(function () {
    if ($(this).closest(".accordion__item").hasClass("accordion__item--open")) {
      $(this).closest(".accordion__item").removeClass("accordion__item--open");
      if ($(this).closest(".accordion__item").find(".accordion__anchor").length) {
        $(window).scrollTop($(this).closest(".accordion__item").find(".accordion__anchor").offset().top);
      }
    } else {
      $(this).closest(".accordion__item").addClass("accordion__item--open");
    }

    if ($accordionItem.length > 0) {
      accordion__init();
    }
  });

  function accordion__init() {
    $accordionItem.each(function () {
      var $el = $(this);
      $el.waypoint({
        handler: function (direction) {
          // Add "stuck" class to open accordion item
          if (direction === "down" && $el.hasClass("accordion__item--open")) {
            $el.addClass("stuck");
          } else {
            $el.removeClass("stuck");
          }
        },
        offset: 0
      });
    });
  } // effects__init()

  /*  ==========================================================================
			Fancybox pop-ups
			========================================================================== */

  function afterFancyboxLoad() {
    // Force effects to always be set to "effect--ready"
    var $popup_effects = $(".fancybox__container .effect");
    if ($popup_effects.length > 0) {
      $popup_effects.each(function () {
        var $el = $(this);
        $el.addClass("effect--ready");
      });
    }
    // Re-init linklines
    links__init();
    // Re-init buttons
    btns__init();
    // Re-init video controls
    plyrs__init();
  }

  Fancybox.bind("[data-fancybox-work]", {
    Thumbs: false,
    mainClass: "fancybox__container--work",
    on: {
      done: (fancybox, slide) => {
        afterFancyboxLoad();
      }
    },
    closeButton: "inside"
  });

  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    on: {
      done: (fancybox, slide) => {
        afterFancyboxLoad();
      }
    },
    Toolbar: {
      display: [{ id: "counter", position: "left" }, "zoom", "fullscreen", "close"]
    }
  });

  /*  ==========================================================================
			Feaured Carousels (Currently used on Featured Posts)
			========================================================================== */

  var $featured_carousels = $(".featured--carousel .carousel");

  if ($featured_carousels.length > 0) {
    featured_carousels__init();
  }

  function featured_carousels__init() {
    $featured_carousels.each(function () {
      var $this = $(this);
      var $slides = $this.find(".col");
      var $this_slidecount = $slides.length;
      if ($this_slidecount > 1) {
        // create resonsive array from col classes
        var classList = $this.find(".col").attr("class").split(/\s+/);
        var responsive_array = [];
        $.each(classList, function (index, item) {
          // if is col width class
          if (item.indexOf("col-") !== -1) {
            var item_width = 0;
            var items_items = 4;
            item = item.replace("col-", "");
            // get min width from col class
            let item_gridsize = item.split("-")[0];
            // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
            if (isNaN(item_gridsize)) {
              item = item.replace(item_gridsize + "-", "");
              item_width = $grid_sizes[item_gridsize];
            } else {
              item_width = 0;
            }
            // split rest of class into sections (this should now be something like "1-4")
            let item_class_sections = item.split("-");
            // divide second number (e.g 4) by first number (e.g 1) to get number of items
            var item_items = "";
            if (item_class_sections[1]) {
              item_items = item_class_sections[1] / item_class_sections[0];
            } else {
              item_items = 1; // if there isn't a second number it must be a single grid
            }
            responsive_array.push({
              breakpoint: parseInt(item_width),
              settings: {
                slidesToShow: item_items
              }
            });
          }
        });

        $this
          .slick({
            infinite: false,
            slidesToShow: 1,
            mobileFirst: true,
            appendArrows: $this.closest(".featured").find(".featured__nav"),
            prevArrow: '<button id="prev" type="button"><i class="fal fa-arrow-left"></i></button>',
            nextArrow: '<button id="next" type="button"><i class="fal fa-arrow-right"></i></button>',
            responsive: responsive_array
          })
          .on("init", function (slick) {
            // on init run our multi slide adaptive height function
            multiSlideAdaptiveHeight(this);
          })
          .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            // on beforeChange run our multi slide adaptive height function
            multiSlideAdaptiveHeight(this);

            // Get slide direction
            var dir;
            if (currentSlide < nextSlide && currentSlide === nextSlide - 1) {
              dir = "right";
            } else if (nextSlide < currentSlide || (nextSlide === slick.slideCount - 1 && currentSlide === 0)) {
              dir = "left";
            }
            if (dir === "right") {
              // Move to next slide - add custom transition
              $slides.eq(currentSlide).addClass("slide-out");
            }
            if (dir === "left") {
              // Move to previous slide - add custom transition
              $slides.eq(currentSlide - 1).removeClass("slide-out");
            }
          })
          .on("afterChange", function (event, slick, currentSlide, nextSlide) {
            Waypoint.refreshAll();
          });

        // when window is resized
        $(window).on("resize", function () {
          // run our multi slide adaptive height function incase current slider active slides change height responsively
          multiSlideAdaptiveHeight($this);
          setTimeout(function () {
            Waypoint.refreshAll();
          }, 500);
        });
      }
    });
  } // featured_carousels__init()

  // our multi slide adaptive height function passing slider object
  function multiSlideAdaptiveHeight(slider) {
    // set our vars
    let activeSlides = [];
    let tallestSlide = 0;

    // very short delay in order for us get the correct active slides
    setTimeout(function () {
      // loop through each active slide for our current slider
      $(".slick-track .slick-active", slider).each(function (item) {
        // add current active slide height to our active slides array
        activeSlides[item] = $(this).outerHeight();
      });

      // for each of the active slides heights
      activeSlides.forEach(function (item) {
        // if current active slide height is greater than tallest slide height
        if (item > tallestSlide) {
          // override tallest slide height to current active slide height
          tallestSlide = item;
        }
      });

      // set the current slider slick list height to current active tallest slide height
      $(slider).height(tallestSlide);
    }, 1000);
  }

  /*  ==========================================================================
			Feaured Work - Work Template Page Header
			========================================================================== */

  var $featuredwork_thumbnails = $(".pageheader--featuredwork .carousel"),
    $featuredwork_fulldetail = $(".featuredwork__fulldetail");

  if ($featuredwork_thumbnails.length > 0 && $featuredwork_fulldetail.length > 0) {
    featured_work_carousel__init();
  }

  function featured_work_carousel__init() {
    var responsive_array = {
      breakpoint: 700,
      settings: {
        slidesToShow: 1
      }
    };

    $featuredwork_fulldetail.slick({
      slidesToShow: 1,
      initialSlide: 0,
      mobileFirst: true,
      arrows: false,
      adaptiveHeight: true,
      fade: true,
      draggable: false,
      asNavFor: ".pageheader--featuredwork .carousel"
    });

    $featuredwork_thumbnails
      .on("init", function (slick) {
        // Fading in the featured work section
        $(".pageheader--featuredwork").addClass("loaded");
        $featuredwork_thumbnails.find(".tile__link").click(function (e) {
          e.preventDefault();
        });
      })
      .slick({
        infinite: true,
        slidesToShow: 2,
        initialSlide: 0,
        focusOnSelect: true,
        mobileFirst: true,
        appendArrows: $featuredwork_thumbnails.closest(".featuredwork__thumbnails").find(".featured__nav"),
        prevArrow: '<button id="prev" type="button"><i class="fal fa-arrow-left"></i></button>',
        nextArrow: '<button id="next" type="button"><i class="fal fa-arrow-right"></i></button>',
        asNavFor: ".featuredwork__fulldetail"
      });

    $(window).resize(function () {
      $featuredwork_fulldetail.slick("reinit");
    });
  } // featured_carousels__init()

  /*  ==========================================================================
			effects
			========================================================================== */

  var $effects = $(".effect");

  if ($effects.length > 0) {
    effects__init();
  }

  function effects__init() {
    $effects.each(function () {
      var $el = $(this);
      $el.waypoint({
        handler: function (direction) {
          if (direction === "down") {
            $el.addClass("effect--ready");
          } else {
            $el.removeClass("effect--ready");
          }
        },
        offset: "90%"
      });
    });
  } // effects__init()

  /*  ==========================================================================
      Initiate plyr (custom video controls)
      ========================================================================== */

  plyrs__init();

  function plyrs__init() {
    if ($(".mediavideo").length) {
      // Get all videos that are click to play
      var $plyrs = $(".mediavideo").not(".mediavideo--autoplay");

      $plyrs.each(function () {
        new Plyr(this, {
          controls: ["play", "progress", "mute", "duration"],
          hideControls: false,
          tooltips: { controls: false, seek: false }
        });
      });
    }
  } // plyrs__init()

  /*  ==========================================================================
			pageheader video background
			========================================================================== */

  // Fade in page header video when ready
  if ($("#pageheadervideo__iframe").length) {
    var iframe = document.getElementById("pageheadervideo__iframe");
    var player = new Vimeo.Player(iframe);
    player.ready().then(function () {
      $("body").addClass("pageheader-video-playing");
    });
  }

  /*  ==========================================================================
			AJAX load more / paging
			========================================================================== */

  $(".paging__loadmore").click(function () {
    var button = $(this);
    var data = {
      action: "loadmore_ad",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };

    var button_text; // create variable to store button text

    // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        button_text = button.html(); // store current button text
        button.text("Loading..."); // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.html(button_text); // set back to previous button text
          $(".posts-container").append(data); // insert new posts to the posts-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.hide();
          }
          // Re-init links to make sure linklines on newly loaded content still work
          links__init();
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });

  /*  ==========================================================================
    FILTERING - URL Parameter functions
    ========================================================================== */

  /* UPDATE URL PARAMETERS */
  function filters__update_url(filter_data, search_data) {
    var url_params = "";

    $.each(filter_data, function (key, value) {
      if (!$.isEmptyObject(value)) {
        if (url_params === "") {
          url_params = url_params + "?";
        } else {
          url_params = url_params + "&";
        }
        // Convert values to comma seperated string
        let values = Object.keys(value)
          .map(function (k) {
            return value[k];
          })
          .join(",");
        url_params = url_params + "filter_" + key + "=" + values;
      }
    });

    if (search_data) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      url_params = url_params + "search=" + search_data;
    }

    var page_url = window.location.href.split("?")[0];
    var new_url = page_url + url_params;

    if (history.pushState) {
      window.history.pushState({ path: new_url }, "", new_url);
    }
  }

  /*  ==========================================================================
			FILTERING - Filter posts
			========================================================================== */

  // Get current filters data from form inputs
  function filters__get_filter_data(form, filters) {
    let filter_data = {};
    $(filters).each(function () {
      filter_data[this.name] = {};
      $("input[type=checkbox][name=" + this.name + "]:checked").each(function (index) {
        filter_data[this.name][index] = $(this).val();
      });
    });
    return filter_data;
  }

  // Setup styling classes on new filter
  function filters__update_styling(filter_data) {
    // Reset styles
    $(".filters__fieldset").removeClass("filters__fieldset--active");
    $(".filters__fieldset__field").removeClass("filters__fieldset__field--active");

    // Reset tags
    $(".filters__tags").removeClass("filters__tags--active");
    $(".filters__activetags__tags").html("");

    $.each(filter_data, function (key, values) {
      if (!$.isEmptyObject(values)) {
        let filter_name = key;
        // Make field group active
        $(".filters__fieldset[data-value='" + key + "']").addClass("filters__fieldset--active");
        $.each(values, function (key, value) {
          // Make input field active
          let filter_input = $("input[name='" + filter_name + "'][value='" + value + "']").closest(
            ".filters__fieldset__field"
          );
          $(filter_input).addClass("filters__fieldset__field--active");
          // Show active tags
          $(".filters__tags").addClass("filters__tags--active");
          // Add tag
          let filter_input_name = $(filter_input).find(".filters__fieldset__field__label").html();
          $(".filters__activetags__tags").append(
            "<div class='filters__tag' data-name='" +
              filter_name +
              "' data-value='" +
              value +
              "'>" +
              filter_input_name +
              "</div>"
          );
        });
      }
    });
  }

  function filters__filter_posts() {
    // Get filters and search passed in to main.js via filters.php
    let filters = filter_settings.filters;
    let search = filter_settings.search;

    let filter_data = filters__get_filter_data($(".filters"), filters);

    let search_data = false;
    if (search) {
      search_data = $(".filters__search input").val();
    }

    if (filter_data || search_data) {
      // Update filter styling and tags
      filters__update_styling(filter_data);

      // Update url
      filters__update_url(filter_data, search_data);

      // If is initial load and there is active tags on search data then trigger ajax, if not initial load then trigger everytime
      if (
        (filters_initial_load && ($(".filters__tags").hasClass("filters__tags--active") || search_data)) ||
        !filters_initial_load
      ) {
        filters_initial_load = false;

        // Scroll to filtering system
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $(".filters-pin").offset().top
          },
          250
        );

        // If there's an active search, open the search field
        if (search_data) {
          $(".filters__search").addClass("filters__search--open");
        }

        // Start filtering
        $(".posts-container").addClass("filtering");

        // Trigger ajax
        var data = {
          action: "filter",
          query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
          page: php_variables.current_page,
          filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
          filter_data: filter_data,
          search_data: search_data
        };

        $.ajax({
          url: php_variables.ajax_url,
          data: data, // form data
          dataType: "json", // this data type allows us to receive objects from the server
          type: "POST",
          beforeSend: function (xhr) {
            $(".filters").find("button").text("Filtering...");
          },
          success: function (data) {
            // when filter applied:
            // set the current page to 1
            php_variables.current_page = 1;

            // set the new query parameters
            php_variables.posts = data.posts;

            // set the new max page parameter
            php_variables.max_page = data.max_page;

            // change the button label back
            $(".filters").find("button").text("Apply filter");

            // insert the posts to the container
            $(".posts-container").html(data.content);

            // hide load more button, if there are not enough posts for the second page
            if (data.max_page < 2) {
              $(".paging__loadmore").hide();
            } else {
              $(".paging__loadmore").show();
            }

            // Finish filtering
            $(".posts-container").removeClass("filtering");
          },
          error: function (data) {}
        });
      }
    }
  }

  // Setup an trigger filtering
  let filters_initial_load = true;

  if ($(".filters").length) {
    // Filter on page load
    filters__filter_posts();

    // Filter on submit
    $(".filters").submit(function (e) {
      filters__filter_posts();

      // do not submit the form
      return false;
    });

    // Submit for on checkbox click
    $(".filters").on("change", "input:checkbox", function () {
      // Update filtering
      $(".filters").submit();
      // Close dropdown
      $(".filters").removeClass("filters--dropdownopen");
    });

    // Dropdown open & close
    $(".filters__dropdownbtn").click(function () {
      $(this).closest(".filters").toggleClass("filters--dropdownopen");
    });

    // Search open & close
    $(".filters__search__icon").click(function () {
      if ($(this).closest(".filters__search").hasClass("filters__search--open")) {
        $(this).closest(".filters__search").removeClass("filters__search--open");
      } else {
        $(this).closest(".filters__search").addClass("filters__search--open");
        $(this).closest(".filters__search").find("input").focus();
      }
    });

    // Remove tags on click
    $(".filters__activetags__tags").on("click", ".filters__tag", function () {
      let filter_name = $(this).data("name");
      let filter_value = $(this).data("value");
      // Unselect input checkbox
      let filter_input = $("input[name='" + filter_name + "'][value='" + filter_value + "']").prop("checked", false);
      // Remove tag
      $(this).remove();
      // Trigger filter
      filters__filter_posts();
    });

    // Clear all
    $(".filters__clearall").click(function () {
      // Clear search
      $(".filters__search").find("input").val("");
      $(".filters__search").removeClass("filters__search--open");
      // Remove all tags
      $(".filters__tags").removeClass("filters__tags--active");
      $(".filters__activetags__tags").html("");
      // Uncheck all inputs
      $(".filters input").prop("checked", false);
      // Trigger filter
      filters__filter_posts();
    });
  }

  /*  ==========================================================================
			NAVIGATION - mobnav
			========================================================================== */

  var $mobnav = $(".mobnav");
  var $siteheaderbd = $(".siteheader__bd");
  var $mobnavtoggle = $(".mobnav-toggle");
  var mobnavopenclass = "mobnavopen";

  mobnav__init();

  function mobnav__init() {
    // Open mobnav on click the toggle
    $mobnavtoggle.on("click touchend", function (e) {
      e.preventDefault();
      if (!$("body").hasClass(mobnavopenclass)) {
        // IT'S NOT OPEN...
        $("body").addClass(mobnavopenclass);
      } else {
        // IT'S OPEN...
        $("body").removeClass(mobnavopenclass);
      }
    });
    $(".mobnavoverlay").on("click touchend", function (e) {
      if ($("body").hasClass(mobnavopenclass)) {
        // Close navigation...
        $("body").removeClass(mobnavopenclass);
      }
    });
  } // mobnav__init()

  $(".sidebar__toggle__text").lettering();
  $(".sidebar").hover(
    function () {
      $(".sidebar").addClass("sidebar--hover");
    },
    function () {
      $(".sidebar").removeClass("sidebar--hover");
    }
  );

  /*  ==========================================================================
			Polyfill IE11 for forEach
			========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

  /*  ==========================================================================
			awards
			========================================================================== */

  $(".awards__loadmore").click(function () {
    this.style.display = "none";
    $(".more_awards").toggleClass("more_awards--open");
  });

  /*  ==========================================================================
			statistics count up
			========================================================================== */

  var $stat = $(".statisticsheading__value");
  var $counted = "counted";

  if ($stat.length > 0) {
    stat__init();
  }

  function stat__init() {
    $stat.each(function () {
      var $el = $(this);
      if ($el.hasClass($counted)) {
        return false;
      } else {
        $el.addClass($counted);
      }
      $el.waypoint({
        handler: function (direction) {
          var a = $el.attr("data-stat-value");
          a = a.indexOf(",") > -1 ? a.replace(",", ".") : a;

          var x = a.split(".")[1] ? a.split(".")[1] : "";
          var b = parseInt(a);

          $el.prop("Counter", 0).animate(
            {
              Counter: b
            },
            {
              duration: 3000,
              easing: "swing",
              step: function (now) {
                var e = parseInt(Math.ceil(now)) + parseFloat(parseInt(a) - b);

                e = $el.text().indexOf(",") > -1 ? e + "," + x : e;
                e = $el.text().indexOf(".") > -1 ? e + "." + x : e;

                $el.text(e);
              }
            }
          );
        },
        offset: "90%"
      });
    });
  } // stat__init()
})(jQuery); // Domready

document.addEventListener("DOMContentLoaded", function () {
  const targetNode = document.querySelector(".awsm-job-listings"); // Adjust the selector if needed

  if (targetNode) {
    const observer = new MutationObserver(function (mutationsList, observer) {
      var $links = $("a").not(".noline, .noline a, .line--added");

      $links.each(function () {
        var $this = $(this);
        var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

        if ($("img", $this).length < 1) {
          $this.wrapInner("<span class='linkline'>");
          $this.addClass("line--added");
          if ($icon.length > 0) {
            if ($icon.hasClass("fa--left")) {
              $icon.insertBefore($(".linkline", $this));
            } else {
              $icon.insertAfter($(".linkline", $this));
            }
          }
        }
      });
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }
});
